import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import mapReimbursement from './mapReimbursement';
import Reimbursement from './Reimbursement';

export interface Result {
	items: Reimbursement;
}

export default async function findReimbursement(client: ApiClient, id: string): Promise<Result> {
	const url = parseTemplate('analytics/virtual-brands/{id}/reimbursement');
	const request = await client.fetch(url.expand({ id }));
	const response = await request.json();
	return { items: response.items.map(mapReimbursement) };
}
